import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { CbreHttpConfig, CbreHttpConfigToken } from '../cbre-http.config';
import { GetStreamOptions, HttpOptions, HttpStrategies } from '../models';
import { HttpMethods } from './http-methods.service';

const defaultHttpOpts: HttpOptions = { data: {}, httpVerb: HttpStrategies.GET };
const defaultGetStreamOpts: GetStreamOptions = { disableCache: false };

@Injectable()
export class HttpStreamsService extends HttpMethods {
  protected streams: Map<string, Observable<any>> = new Map();
  constructor(http: HttpClient, @Inject(CbreHttpConfigToken) options: CbreHttpConfig) {
    super(http, options);
  }

  /**
   * Return a shared observable if url already exists and options.disableCache is false
   * else it creates a shared observable through network call
   *
   * @param url: {string}
   * @param opts: {HttpOptions}
   * @param streamOpts: {GetStreamOptions}
   *
   * @returns Observable<any>
   */
  public loadDataFor(url: string);
  public loadDataFor(url: string, opts: HttpOptions, disableCache: boolean);
  public loadDataFor(
    url: string,
    { data = {}, httpVerb = HttpStrategies.GET }: HttpOptions = defaultHttpOpts,
    streamOpts: GetStreamOptions | boolean = defaultGetStreamOpts
  ): Observable<any> {
    if (typeof streamOpts === 'boolean') {
      streamOpts = { disableCache: streamOpts };
    }
    return this.getStream(url, httpVerb, streamOpts.disableCache, data);
  }

  public getStream(url, httpVerb: HttpStrategies = HttpStrategies.GET, disableCache = false, data?: any) {
    if (!this.streams.has(url) || disableCache) {
      this.createStream(url, httpVerb, data);
    }
    return this.streams.get(url);
  }

  public createStream(url, httpVerb: HttpStrategies, data = {}) {
    const requestKey = url;
    if (['?all=false', 'POST:'].some(token => url.includes(token))) {
      url = url.replace('POST:', '');
      httpVerb = HttpStrategies.POST;
    }
    if (httpVerb === HttpStrategies.POST) {
      this.streams.set(
        requestKey,
        this.httpPost(url, data).pipe(
          publishReplay(1),
          refCount()
        )
      );
    } else {
      this.streams.set(
        requestKey,
        this.httpGet(url).pipe(
          publishReplay(1),
          refCount()
        )
      );
    }
  }
}
